export const FETCH_RESULT = 'TASTE_PROFILE_ONBOARDING/FETCH_RESULT'
export const FETCH_RESULT_SUCCESS = 'TASTE_PROFILE_ONBOARDING/FETCH_RESULT_SUCCESS'
export const FETCH_RESULT_FAILURE = 'TASTE_PROFILE_ONBOARDING/FETCH_RESULT_FAILURE'
export const CLEAR_RESULT = 'TASTE_PROFILE_ONBOARDING/CLEAR_RESULT'

// we need to send the results here
export function fetchResults (delayTime = 0) {
  return {
    type: FETCH_RESULT,
    delayTime
  }
}

export function fetchResultsSuccess (result) {
  return {
    type: FETCH_RESULT_SUCCESS,
    result
  }
}

export function fetchResultsFailure () {
  return {
    type: FETCH_RESULT_FAILURE,
    error: {
      fetchResultFailed: true
    }
  }
}

export function clearResult () {
  return {
    type: CLEAR_RESULT
  }
}
